export enum OpenWebViewEnum {
  /**
   * 在开启的 `VRWebView` 栈中追加一个 `WebView`。
   */
  Append = 'Append',
  /**
   * 强制 先关闭当前的 `VRWebiView` 然后开启新的 `VRWebView`。
   */
  Replace = 'Replace',
  /**
   * 删除所有的 `VRWebView`，仅保留本次新开启的 `VRWebView`。
   */
  Single = 'Single'
}